// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlanoContas_ValorInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /planocontas/{id}/valor
 *
 * Updates the predicted value for a fixed budget account.
 */
import { registerContract } from './validate'

export interface PlanoContas_ValorInput {
valor: number
}

registerContract('PlanoContas_ValorInput', {
  valor: { type: 'number',  required: true },
})
